var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { toRef, computed } from 'vue';
import useAmadeusParams from '../../hooks/useAmadeusParams';
import { defaultCabinInputValues } from '../CabinInput/types';
import AmadeusFormSubmission from '../AmadeusFormSubmission/AmadeusFormSubmission.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AmadeusBookingUrl',
    props: {
        itineraries: {},
        passengerAndCabinClass: { default: function () { return defaultCabinInputValues; } },
        promoCode: { default: '' },
        paramsSource: { default: undefined }
    },
    setup: function (__props) {
        var props = __props;
        var itinerariesRef = toRef(props, 'itineraries');
        var passengerAndCabinClassRef = computed(function () {
            var _a;
            return (__assign(__assign({}, defaultCabinInputValues), ((_a = props.passengerAndCabinClass) !== null && _a !== void 0 ? _a : {})));
        });
        var promoCodeRef = toRef(props, 'promoCode');
        var params = useAmadeusParams({
            itinerariesRef: itinerariesRef,
            passengerAndCabinClassRef: passengerAndCabinClassRef,
            promoCodeRef: promoCodeRef,
            paramsSource: props.paramsSource,
        });
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(AmadeusFormSubmission, {
                refx: "",
                params: _unref(params)
            }, {
                default: _withCtx(function () { return [
                    _renderSlot(_ctx.$slots, "default", { params: _unref(params) })
                ]; }),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["params"]));
        };
    }
});
